/* global Promise */
'use strict';

var commons = require('../../../commons/httpClient');
var httpClient = commons.httpClient;
var store = require('adyen_config/store');
var helpers = require('../../../checkout/helpers');
var constants = require('adyen_config/constants');
var GOOGLE_PAY = constants.GOOGLE_PAY;
var GOOGLE_PAY_CALLBACK_TRIGGERS = constants.GOOGLE_PAY_CALLBACK_TRIGGERS;
var initCheckout = require('../../initializeCheckout');
var initializeCheckout = initCheckout.initializeCheckout;
var adyenCommons = require('../../../commons');
var createTemporaryBasket = adyenCommons.createTemporaryBasket;

function GooglePay(config, applicationInfo, adyenTranslations, isExpressPdp, initialAmount) {
    var basketAmount = window.basketAmount;
    var showConfirmationAction = window.showConfirmationAction;
    var shippingMethodsUrl = window.shippingMethodsUrl;
    var selectShippingMethodUrl = window.selectShippingMethodUrl;
    var paymentFromComponentURL = window.paymentFromComponentURL;

    this.store = store;
    this.helpers = helpers;
    this.amount = initialAmount || JSON.parse(basketAmount);
    this.showPayButton = true;
    this.isExpress = true;
    this.isExpressPdp = isExpressPdp;
    this.paymentFromComponentURL = paymentFromComponentURL;
    this.showConfirmationAction = showConfirmationAction;
    this.shippingMethodsUrl = shippingMethodsUrl;
    this.selectShippingMethodUrl = selectShippingMethodUrl;
    this.applicationInfo = applicationInfo;
    this.translations = adyenTranslations;
    this.config = config;
    this.document = document;
}

GooglePay.formatCustomerObject = function (customerData) {
    var shippingData = customerData.shippingAddress;
    var billingData = customerData.paymentMethodData.info.billingAddress;
    var nameParts = customerData.shippingAddress.name.split(' ');
    var firstName = nameParts[0];
    var lastName = nameParts.length > 1 ? nameParts.slice(1).join(' ') : '';
    return {
        addressBook: {
            addresses: {},
            preferredAddress: {
                address1: shippingData.address1,
                address2: shippingData.address2 ? shippingData.address2 : null,
                city: shippingData.locality,
                countryCode: {
                    displayValue: shippingData.countryCode,
                    value: shippingData.countryCode
                },
                firstName: firstName,
                lastName: lastName,
                ID: customerData.email,
                postalCode: shippingData.postalCode,
                stateCode: shippingData.administrativeArea
            }
        },
        billingAddressDetails: {
            address1: billingData.address1,
            address2: billingData.address2 ? billingData.address2 : null,
            city: billingData.locality,
            countryCode: {
                displayValue: billingData.countryCode,
                value: billingData.countryCode
            },
            firstName: firstName,
            lastName: lastName,
            postalCode: billingData.postalCode,
            stateCode: billingData.administrativeArea
        },
        customer: {},
        profile: {
            firstName: firstName,
            lastName: lastName,
            email: customerData.email,
            phone: shippingData.phoneNumber
        }
    };
};

GooglePay.prototype.getShippingMethods = function (shippingAddress) {
    var requestBody = {
        paymentMethodType: GOOGLE_PAY,
        isExpressPdp: this.isExpressPdp
    };
    if (shippingAddress) {
        requestBody.address = {
            city: shippingAddress.locality,
            country: shippingAddress.country,
            countryCode: shippingAddress.countryCode,
            stateCode: shippingAddress.administrativeArea,
            postalCode: shippingAddress.postalCode
        };
    }
    return httpClient({
        method: 'POST',
        url: this.shippingMethodsUrl,
        data: {
            data: JSON.stringify(requestBody)
        }
    });
};

GooglePay.prototype.selectShippingMethod = function (method) {
    var requestBody = {
        paymentMethodType: GOOGLE_PAY,
        shipmentUUID: method.shipmentUUID,
        methodID: method.ID,
        isExpressPdp: this.isExpressPdp
    };
    return httpClient({
        method: 'POST',
        url: this.selectShippingMethodUrl,
        data: {
            data: JSON.stringify(requestBody)
        }
    });
};

GooglePay.getTransactionInfo = function (newCalculation) {
    return {
        countryCode: newCalculation && newCalculation.locale ? newCalculation.locale.slice(-2) : '',
        currencyCode: newCalculation && newCalculation.grandTotalAmount ? newCalculation.grandTotalAmount.currency : '',
        totalPriceStatus: 'FINAL',
        totalPriceLabel: 'Total',
        totalPrice: newCalculation && newCalculation.grandTotalAmount ? String(newCalculation.grandTotalAmount.value) : ''
    };
};

GooglePay.getShippingOptionsParameters = function (selectedShippingMethod, shippingMethodsData) {
    return {
        defaultSelectedOptionId: selectedShippingMethod.ID,
        shippingOptions: shippingMethodsData.shippingMethods.map(function (sm) {
            return {
                label: sm.displayName,
                description: sm.description,
                id: sm.ID
            };
        })
    };
};

GooglePay.submitSuccessForm = function (response) {
    if (document.querySelector('#result')) {
        var fullResponse = response.fullResponse || {};
        document.querySelector('#result').value = JSON.stringify({
            pspReference: fullResponse.pspReference,
            resultCode: fullResponse.resultCode,
            // eslint-disable-next-line no-nested-ternary
            paymentMethod: fullResponse.paymentMethod
                ? fullResponse.paymentMethod
                : (fullResponse.additionalData ? fullResponse.additionalData.paymentMethod : ''),
            donationToken: fullResponse.donationToken,
            amount: fullResponse.amount
        });
    }
    var form = document.querySelector('#showConfirmationForm');
    if (form) {
        form.submit();
    }
};

GooglePay.handleError = function (reject) {
    if (reject) {
        reject();
    }
    if (document.querySelector('#result')) {
        document.querySelector('#result').value = JSON.stringify({
            error: true
        });
    }
    var form = document.querySelector('#showConfirmationForm');
    if (form) {
        form.submit();
    }
};

GooglePay.stopSpinner = function () {
    if ($ && $.spinner) {
        var spinnerFn = $.spinner();
        if (spinnerFn && spinnerFn.stop) {
            spinnerFn.stop();
        }
    }
};

GooglePay.prototype.onShippingAddressChange = function (shippingAddress) {
    var self = this;
    return this.getShippingMethods(shippingAddress).then(function (shippingMethodsData) {
        if (shippingMethodsData && shippingMethodsData.shippingMethods && shippingMethodsData.shippingMethods.length) {
            var selectedShippingMethod = shippingMethodsData.shippingMethods[0];
            return self.selectShippingMethod(selectedShippingMethod).then(function (newCalculation) {
                if (newCalculation && newCalculation.grandTotalAmount) {
                    return {
                        newShippingOptionParameters: GooglePay.getShippingOptionsParameters(
                            selectedShippingMethod,
                            shippingMethodsData
                        ),
                        newTransactionInfo: GooglePay.getTransactionInfo(
                            newCalculation,
                            shippingMethodsData
                        )
                    };
                }
                return {
                    error: {
                        reason: 'SHIPPING_ADDRESS_UNSERVICEABLE',
                        message: 'Cannot ship to the selected address',
                        intent: 'SHIPPING_ADDRESS'
                    }
                };
            });
        }
        return {
            error: {
                reason: 'SHIPPING_ADDRESS_UNSERVICEABLE',
                message: 'Cannot ship to the selected address',
                intent: 'SHIPPING_ADDRESS'
            }
        };
    });
};

GooglePay.prototype.onShippingOptionChange = function (shippingAddress, shippingOptionData) {
    var self = this;
    return this.getShippingMethods(shippingAddress).then(function (shippingMethodsData) {
        var shippingMethods = (shippingMethodsData && shippingMethodsData.shippingMethods) || [];
        var matchingShippingMethod = shippingMethods.find(function (sm) {
            return sm.ID === shippingOptionData.id;
        });
        return self.selectShippingMethod(matchingShippingMethod).then(function (newCalculation) {
            if (newCalculation && newCalculation.grandTotalAmount) {
                return {
                    newTransactionInfo: GooglePay.getTransactionInfo(
                        newCalculation,
                        shippingMethodsData
                    )
                };
            }
            return {
                error: {
                    reason: 'SHIPPING_ADDRESS_UNSERVICEABLE',
                    message: 'Cannot ship to the selected address',
                    intent: 'SHIPPING_OPTION'
                }
            };
        });
    });
};

GooglePay.prototype.onAdditionalDetails = function (state) {
    this.document.querySelector('#additionalDetailsHidden').value = JSON.stringify($.extend({}, state.data, {
        paymentData: {}
    }));
    this.document.querySelector('#showConfirmationForm').submit();
};

GooglePay.prototype.onAuthorized = function (data, actions) {
    var authorizedEvent = data.authorizedEvent;
    try {
        this.customer = GooglePay.formatCustomerObject(authorizedEvent);
        actions.resolve();
    } catch (error) {
        actions.reject();
    }
    return Promise.resolve();
};

GooglePay.prototype.callPaymentFromComponent = function (data) {
    return httpClient({
        url: this.paymentFromComponentURL,
        method: 'POST',
        data: {
            data: JSON.stringify(data),
            paymentMethod: GOOGLE_PAY
        }
    });
};

GooglePay.prototype.onSubmit = function (state, component, actions) {
    var self = this;
    try {
        if ($ && $.spinner) {
            $.spinner().start();
        }
        var stateData = $.extend({}, state.data, {
            paymentType: 'express'
        });
        return this.callPaymentFromComponent($.extend({}, stateData, {
            customer: this.customer,
            isExpressPdp: this.isExpressPdp
        })).then(function (response) {
            if (!response || !response.resultCode) {
                GooglePay.handleError(actions.reject);
                return;
            }

            helpers.createShowConfirmationForm(self.showConfirmationAction);
            if (self.isExpressPdp) {
                self.helpers.setExpressRedirectUrl();
            }
            helpers.setOrderFormData(response);
            document.querySelector('#additionalDetailsHidden').value = JSON.stringify($.extend({}, stateData, response));

            actions.resolve({
                resultCode: response.resultCode,
                action: response.fullResponse && response.fullResponse.action
            });
            if (response.resultCode === 'Authorised') {
                GooglePay.submitSuccessForm(response);
            }
            GooglePay.stopSpinner();
        }).catch(function () {
            GooglePay.stopSpinner();
            GooglePay.handleError(actions.reject);
        });
    } catch (error) {
        GooglePay.stopSpinner();
        GooglePay.handleError(actions.reject);
    }
    return Promise.resolve();
};

GooglePay.prototype.onPaymentDataChanged = function (intermediatePaymentData) {
    var self = this;
    var callbackTrigger = intermediatePaymentData.callbackTrigger;
    var shippingAddress = intermediatePaymentData.shippingAddress;
    var shippingOptionData = intermediatePaymentData.shippingOptionData;

    var paymentDataRequestUpdatePromise = Promise.resolve({});

    if (callbackTrigger === GOOGLE_PAY_CALLBACK_TRIGGERS.INITIALIZE) {
        var basePromise = this.isExpressPdp ? createTemporaryBasket() : Promise.resolve();
        paymentDataRequestUpdatePromise = basePromise.then(function () {
            return self.onShippingAddressChange(shippingAddress);
        });
    } else if (callbackTrigger === GOOGLE_PAY_CALLBACK_TRIGGERS.SHIPPING_ADDRESS) {
        paymentDataRequestUpdatePromise = this.onShippingAddressChange(shippingAddress);
    } else if (callbackTrigger === GOOGLE_PAY_CALLBACK_TRIGGERS.SHIPPING_OPTION) {
        paymentDataRequestUpdatePromise = this.onShippingOptionChange(shippingAddress, shippingOptionData);
    }

    return paymentDataRequestUpdatePromise;
};

GooglePay.prototype.getConfig = function () {
    return {
        showPayButton: this.showPayButton,
        isExpress: this.isExpress,
        buttonType: 'buy',
        emailRequired: true,
        shippingAddressRequired: true,
        shippingOptionRequired: true,
        shippingAddressParameters: {
            phoneNumberRequired: true
        },
        billingAddressRequired: true,
        billingAddressParameters: {
            format: 'FULL',
            phoneNumberRequired: true
        },
        gatewayMerchantId: window.merchantAccount,
        configuration: this.config,
        callbackIntents: ['SHIPPING_ADDRESS', 'SHIPPING_OPTION'],
        amount: this.amount,
        onAdditionalDetails: this.onAdditionalDetails.bind(this),
        onAuthorized: this.onAuthorized.bind(this),
        onSubmit: this.onSubmit.bind(this),
        paymentDataCallbacks: {
            onPaymentDataChanged: this.onPaymentDataChanged.bind(this)
        }
    };
};

GooglePay.prototype.getComponent = function () {
    var self = this;
    return initializeCheckout(
        this.applicationInfo,
        this.translations
    ).then(function (checkout) {
        var googlePayConfig = self.getConfig();
        return window.AdyenWeb.createComponent(
            GOOGLE_PAY,
            checkout,
            googlePayConfig
        );
    });
};

module.exports = GooglePay;
